import DataTable from 'react-data-table-component';
import { Button, Badge } from 'react-bootstrap';
import { sortByDate } from '../../helpers/helperFunction';

const UserManagementDataTable = ({ data, loadingData, openModal }) => {

  const getAccountStatus = (status) => {
    let style = { color: '#1faf38', background: 'rgba(31,175,56,0.2)' };

    if (status === true) {
      style = { color: '#f15a24', background: 'rgba(241,90,36,0.2)' };
    }

    return <Badge style={style}>{status === true ? 'Suspended' : 'Active'}</Badge>;
  };

  const dateOptions = {
    month: 'long',
    day: 'numeric',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    hour12: true,
  };

  const sortID =(rowA, rowB) => {
    const idA = parseInt(rowA.id)
    const idB = parseInt(rowB.id)
    if (idA > idB) {
      return 1
    }
    return -1
  }

  const columnsAll = [
    {
      name: 'Name',
      sortable: true,
      selector: (row) => row.name,
    },
    {
      name: 'Email',
      sortable: true,
      selector: (row) => row.email,
    },
    {
      name: 'User ID',
      sortable: true,
      selector: (row) => row.id.toString(),
      sortFunction: sortID
    },
    {
      name: 'Created At',
      sortable: true,
      selector: (row) => row.created_at,
      sortFunction: sortByDate('created_at'),
    },
    {
      name: 'User Account Status',
      selector: (row) => getAccountStatus(row.is_deleted),
    },
    {
      name: 'Role',
      selector: (row) => row.role,
    },
    {
      name: 'Actions',
      minWidth: '150px',
      selector: (row) => (
        <div className="d-flex justify-content-center align-items-center gap-1">
          <Button
            variant="primary"
            onClick={() => openModal('edit', row)}
            style={{ minWidth: 100 }}
          >
            Edit
          </Button>
        </div>
      ),
    },
  ];

  return (
    <>
      <DataTable
        columns={columnsAll}
        data={data}
        progressPending={loadingData}
        paginationComponentOptions={{
          rowsPerPageText: 'Items per page:',
        }}
        pagination
      />
    </>
  );
};

export default UserManagementDataTable;
